/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["user-access-manager{display:block}user-access-manager .panel-outter{margin:10px 0 20px}user-access-manager .panel-outter>.header{display:flex;margin-bottom:10px;padding-bottom:10px;border-bottom:1px solid #e0e0e0;align-items:flex-end}user-access-manager .panel-outter>.header>.title{font-weight:500}user-access-manager .panel-outter>.header>.add-button{text-align:right;flex:1 1 auto}"];
export { styles as styles };
